<div class="header-button ">
  <button mat-button class="header-item sidebar-collapse" (click)="toggleMenu()">
    <a class="pc-head-link">
     
      <fa-icon [ngStyle]="{color:'white'}" [icon]="faMenu"></fa-icon>

    </a>
  </button>


</div>
